module.exports = __webpack_public_path__ + "static/media/RestDayCup.73ac9299.svg";